module.exports = __webpack_public_path__ + "img/mobile-layout-03.efbc517c.jpg";